import { i18n } from 'next-i18next';

import { replaceBaseOrigin } from '@kc-console/core';

import env from './env';

const DEFAULT_LANGUAGE = 'ko';

/**
 * 사용자 가이드 경로 URL을 생성합니다.
 * baseUrl은 다음 순서로 결정됩니다: KC_DOCS_URL → KC_IAM_ENDPOINT 기반 docs 도메인(replaceBaseOrigin).
 * userGuidePath가 http로 시작하는 전체 URL이면 그대로 반환합니다.
 *
 * @param userGuidePath - 사용자 가이드 경로(미제공 시 baseUrl만 반환, 전체 URL이면 그대로 반환)
 * @returns 가이드 전체 URL (`${baseUrl}/${언어}/${userGuidePath}`)
 *
 * @example
 * getUserGuidePath('service/management/iam/roles/org-roles');
 * // https://docs.kakaocloud.com/ko/service/management/iam/roles/org-roles
 *
 * getUserGuidePath('https://kakaocloud.com/services/secrets-manager/intro');
 * // https://kakaocloud.com/services/secrets-manager/intro (그대로 반환)
 */
function getUserGuidePath(userGuidePath?: string): string {
  const alt = replaceBaseOrigin(env.KC_IAM_ENDPOINT || '', 'docs');
  const basePath = env.KC_DOCS_URL ?? alt;

  const lng = i18n?.language ?? DEFAULT_LANGUAGE;

  const basePathWithLng = lng !== DEFAULT_LANGUAGE ? `${basePath}/${lng}` : basePath;

  if (!userGuidePath) {
    return basePathWithLng;
  }

  if (userGuidePath.startsWith('http')) {
    return userGuidePath;
  }

  let path = userGuidePath;
  if (path.startsWith('/')) {
    path = path.slice(1);
  }

  return `${basePathWithLng}/${path}`;
}

export default getUserGuidePath;
